export default __webpack_public_path__ + "static/media/corners.c98b76d4.md";